(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v2-contact-form')) {
    customElements.define(
      'v2-contact-form',
      class V2ContactForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form) return;
          const notice = this.querySelector('[data-contact-notice]');
          if (notice) {
            notice.scrollIntoView({ block: 'center' });
            notice.focus({ preventScroll: true });
          }
          this.form.addEventListener('submit', (event) => {
            if (!this.validate()) event.preventDefault();
          });
          this.form.addEventListener('input', (event) => {
            if (event.target.getAttribute('aria-invalid') === 'true') this.check(event.target);
          });
          this.form.addEventListener('change', (event) => {
            if (event.target.getAttribute('aria-invalid') === 'true') this.check(event.target);
          });
        }

        fields() {
          return [...this.form.querySelectorAll('input[required], select[required], textarea[required]')];
        }

        check(field) {
          const value = field.value.trim();
          let message = '';
          if (!value) {
            message = this.dataset.required;
          } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            message = this.dataset.email;
          }
          const error = document.getElementById(field.getAttribute('aria-describedby'));
          if (message) {
            field.setAttribute('aria-invalid', 'true');
            if (error) {
              error.textContent = message;
              error.hidden = false;
            }
          } else {
            field.removeAttribute('aria-invalid');
            if (error) {
              error.textContent = '';
              error.hidden = true;
            }
          }
          return !message;
        }

        validate() {
          let firstInvalid = null;
          this.fields().forEach((field) => {
            if (!this.check(field) && !firstInvalid) firstInvalid = field;
          });
          if (firstInvalid) firstInvalid.focus();
          return !firstInvalid;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-favorites"]) return;
  try {
    
  if (!customElements.get('v2-favorites-list')) {
    customElements.define(
      'v2-favorites-list',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-favorites-list]');
          this.empty = this.querySelector('[data-favorites-empty]');
          this.render();
          document.addEventListener('abajuu:favorites-change', this.onChange);
        }

        disconnectedCallback() {
          document.removeEventListener('abajuu:favorites-change', this.onChange);
        }

        onChange = () => {
          const handles = this.readHandles();
          this.list.querySelectorAll('[data-handle-item]').forEach((item) => {
            if (!handles.includes(item.dataset.handleItem)) item.remove();
          });
          this.empty.hidden = this.list.children.length > 0;
        };

        readHandles() {
          try {
            const list = JSON.parse(localStorage.getItem('abajuu:favorites') || '[]');
            return Array.isArray(list) ? list : [];
          } catch (error) {
            return [];
          }
        }

        async render() {
          const handles = this.readHandles();
          if (!handles.length) {
            this.empty.hidden = false;
            return;
          }
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const results = await Promise.all(
            handles.map((handle) =>
              fetch(`${root}products/${encodeURIComponent(handle)}?view=v2-card`)
                .then((response) => (response.ok ? response.text() : null))
                .then((html) => ({ handle, html }))
                .catch(() => ({ handle, html: null }))
            )
          );
          const items = results.filter((result) => result.html && result.html.includes('v2-card'));
          this.list.innerHTML = items
            .map((item) => `<li data-handle-item="${item.handle.replace(/"/g, '')}">${item.html}</li>`)
            .join('');
          this.empty.hidden = items.length > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v2-daynight')) {
    customElements.define(
      'v2-daynight',
      class extends HTMLElement {
        connectedCallback() {
          this.slide = this.closest('.v2-hero__slide');
          this.options = [...this.querySelectorAll('[data-mode]')];
          this.status = this.querySelector('[data-daynight-status]');
          this.options.forEach((option) => option.addEventListener('click', () => this.set(option.dataset.mode)));
        }

        set(mode) {
          const night = mode === 'night';
          this.slide?.classList.toggle('is-night', night);
          this.options.forEach((option) => option.setAttribute('aria-pressed', String(option.dataset.mode === mode)));
          if (this.status) this.status.textContent = night ? this.dataset.nightStatus : this.dataset.dayStatus;
        }
      }
    );
  }

  if (!customElements.get('v2-hero')) {
    customElements.define(
      'v2-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-hero-track]');
          this.slides = [...this.querySelectorAll('[data-hero-slide]')];
          this.dots = [...this.querySelectorAll('[data-hero-dot]')];
          this.index = 0;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.slides.length < 2) return;

          this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1));
          this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.heroDot))));
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.addEventListener('keydown', this.onKeydown);

          if (this.dataset.autoplay === 'true' && !this.reduceMotion) {
            this.speed = Math.max(Number(this.dataset.speed) || 6000, 3000);
            this.addEventListener('mouseenter', this.pause);
            this.addEventListener('mouseleave', this.play);
            this.addEventListener('focusin', this.pause);
            this.addEventListener('focusout', this.play);
            document.addEventListener('visibilitychange', this.onVisibility);
            this.play();
          }
          this.setActive(0);
        }

        disconnectedCallback() {
          this.pause();
          document.removeEventListener('visibilitychange', this.onVisibility);
        }

        go(index) {
          const count = this.slides.length;
          const next = (index + count) % count;
          this.track.scrollTo({ left: this.slides[next].offsetLeft, behavior: this.reduceMotion ? 'auto' : 'smooth' });
          this.setActive(next);
        }

        setActive(index) {
          this.index = index;
          this.dots.forEach((dot, i) => {
            if (i === index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
          this.slides.forEach((slide, i) => {
            slide.querySelectorAll('[data-hero-focusable]').forEach((el) => {
              if (i === index) {
                el.removeAttribute('tabindex');
              } else {
                el.setAttribute('tabindex', '-1');
              }
            });
          });
        }

        onScroll = () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => {
            const width = this.track.clientWidth || 1;
            const index = Math.round(this.track.scrollLeft / width);
            if (index !== this.index) this.setActive(Math.min(Math.max(index, 0), this.slides.length - 1));
          }, 80);
        };

        onKeydown = (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index - 1);
          }
        };

        play = () => {
          if (!this.speed) return;
          this.pause();
          this.timer = window.setInterval(() => this.go(this.index + 1), this.speed);
        };

        pause = () => {
          window.clearInterval(this.timer);
        };

        onVisibility = () => {
          if (document.hidden) {
            this.pause();
          } else {
            this.play();
          }
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-legal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Cookie policy: show the "manage preferences" button only when Shopify's cookie banner is active.
    const setup = () => {
      document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
        if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
        button.hidden = false;
        if (button.dataset.bound) return;
        button.dataset.bound = 'true';
        button.addEventListener('click', () => window.privacyBanner.showPreferences());
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
    window.addEventListener('load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-main-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v2-facets')) {
    class V2Facets extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-facets-form]');
        this.panel = this.querySelector('[data-facets-panel]');
        this.openButton = this.querySelector('[data-facets-open]');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.filters = [...this.querySelectorAll('[data-filter]')];

        this.form.addEventListener('submit', () => this.disableEmpty());
        this.form.addEventListener('change', (event) => {
          const target = event.target;
          if (target.matches('[data-autosubmit]')) return this.submit();
          if (target.type === 'checkbox' && !this.isDrawerOpen()) this.submit();
        });

        this.openButton?.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-facets-close]').forEach((el) => el.addEventListener('click', () => this.close()));

        this.filters.forEach((details) =>
          details.addEventListener('toggle', () => {
            if (!details.open || !this.desktop.matches) return;
            this.filters.forEach((other) => {
              if (other !== details) other.open = false;
            });
          })
        );

        this.onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          if (this.isDrawerOpen()) return this.close();
          const openFilter = this.filters.find((details) => details.open);
          if (openFilter && this.desktop.matches) {
            openFilter.open = false;
            openFilter.querySelector('summary').focus();
          }
        };
        document.addEventListener('keydown', this.onKeydown);

        this.onDocumentClick = (event) => {
          if (!this.desktop.matches || event.target.closest('[data-filter]')) return;
          this.filters.forEach((details) => (details.open = false));
        };
        document.addEventListener('click', this.onDocumentClick);

        this.onBreakpoint = () => this.close(false);
        this.desktop.addEventListener('change', this.onBreakpoint);

        this.onPageShow = () => {
          this.form.querySelectorAll('[data-v2-emptied]').forEach((el) => {
            el.disabled = false;
            el.removeAttribute('data-v2-emptied');
          });
        };
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
        this.desktop.removeEventListener('change', this.onBreakpoint);
        window.removeEventListener('pageshow', this.onPageShow);
        document.documentElement.classList.remove('v2-scroll-lock');
      }

      isDrawerOpen() {
        return Boolean(this.panel && this.panel.classList.contains('is-open'));
      }

      disableEmpty() {
        this.form.querySelectorAll('input:not([type=checkbox]), select').forEach((el) => {
          if (!el.disabled && el.value === '') {
            el.disabled = true;
            el.setAttribute('data-v2-emptied', '');
          }
        });
      }

      submit() {
        this.disableEmpty();
        this.form.submit();
      }

      open() {
        if (!this.panel) return;
        this.panel.classList.add('is-open');
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
        this.openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('v2-scroll-lock');
        const closeButton = this.panel.querySelector('.v2-facets__close');
        if (typeof trapFocus === 'function') {
          trapFocus(this.panel, closeButton);
        } else {
          closeButton?.focus();
        }
      }

      close(returnFocus = true) {
        if (!this.isDrawerOpen()) return;
        this.panel.classList.remove('is-open');
        this.panel.removeAttribute('role');
        this.panel.removeAttribute('aria-modal');
        this.openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('v2-scroll-lock');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(returnFocus ? this.openButton : null);
        } else if (returnFocus) {
          this.openButton.focus();
        }
      }
    }

    customElements.define('v2-facets', V2Facets);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-main-product"]) return;
  try {
    
  if (!customElements.get('v2-buybar')) {
    customElements.define(
      'v2-buybar',
      class extends HTMLElement {
        connectedCallback() {
          const form = document.getElementById(this.dataset.formId);
          this.formQty = form?.querySelector('input[name="quantity"]');
          this.formButton = form?.querySelector('[type="submit"]');
          this.qty = this.querySelector('[data-buybar-qty]');
          this.button = this.querySelector('[data-buybar-atc]');
          this.label = this.querySelector('[data-buybar-label]');
          this.spinner = this.button?.querySelector('.loading__spinner');

          // Quantity: the form's field is the one that is submitted, so copy the bar's value into it both ways.
          if (this.qty && this.formQty) {
            this.qty.addEventListener('change', () => (this.formQty.value = this.qty.value));
            this.formQty.addEventListener('change', () => (this.qty.value = this.formQty.value));
          }
          // Copy the quantity right before the form is sent, in case the field was typed into.
          this.button?.addEventListener('click', () => {
            if (this.qty && this.formQty) this.formQty.value = this.qty.value;
          });

          // Button: mirror the form button's state (adding, sold out, label), so it cannot be pressed twice.
          if (this.formButton && this.button) {
            this.observer = new MutationObserver(() => this.sync());
            this.observer.observe(this.formButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
            this.sync();
          }

          // Page end padding equals the bar's real height (safe area included).
          this.resizeObserver = new ResizeObserver(() => {
            if (this.offsetHeight) document.documentElement.style.setProperty('--v2-buybar-height', this.offsetHeight + 'px');
          });
          this.resizeObserver.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.resizeObserver?.disconnect();
        }

        sync() {
          const source = this.formButton;
          this.button.disabled = source.disabled;
          if (source.hasAttribute('aria-disabled')) {
            this.button.setAttribute('aria-disabled', source.getAttribute('aria-disabled'));
          } else {
            this.button.removeAttribute('aria-disabled');
          }
          const loading = source.classList.contains('loading');
          this.button.classList.toggle('loading', loading);
          this.spinner?.classList.toggle('hidden', !loading);
          const text = source.querySelector('span')?.textContent.trim();
          if (text && this.label) this.label.textContent = text;
        }
      }
    );
  }

  if (!customElements.get('v2-product-video')) {
    customElements.define(
      'v2-product-video',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-video-dialog]');
          this.frame = this.querySelector('[data-video-frame]');
          this.template = this.querySelector('[data-video-template]');
          this.opener = this.querySelector('[data-video-open]');
          if (!this.dialog || !this.frame || !this.template || !this.opener) return;

          this.opener.addEventListener('click', this.open);
          this.querySelector('[data-video-close]')?.addEventListener('click', () => this.dialog.close());
          // The dialog fills the screen; a click on it (not on the video) is a click on the dark backdrop.
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', this.onClose);
        }

        open = () => {
          if (this.dialog.open) return;
          // The video is only created when the pop-up opens, so nothing loads before the click.
          this.frame.replaceChildren(this.template.content.cloneNode(true));
          document.documentElement.classList.add('v2-video-lock');
          this.dialog.showModal();
          const video = this.frame.querySelector('video');
          if (!video) return;
          const playing = video.play();
          if (playing) {
            // Some browsers block autoplay with sound; then start muted and let the visitor turn the sound on.
            playing.catch(() => {
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        };

        onClose = () => {
          const video = this.frame.querySelector('video');
          if (video) {
            video.pause();
            video.querySelectorAll('source').forEach((source) => source.remove());
            video.removeAttribute('src');
            video.load();
          }
          this.frame.replaceChildren();
          document.documentElement.classList.remove('v2-video-lock');
          this.opener.focus({ preventScroll: true });
        };
      }
    );
  }


  if (!customElements.get('v2-product-gallery')) {
    customElements.define(
      'v2-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gallery-track]');
          this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
          this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
          this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
          this.counter = this.querySelector('[data-gallery-current]');
          this.lightbox = this.querySelector('[data-lightbox]');
          this.zoomButtons = [...this.querySelectorAll('[data-gallery-open]')];
          this.index = 0;

          this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(Number(thumb.dataset.galleryThumb))));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.galleryDot))));
          this.track?.addEventListener('scroll', this.onScroll, { passive: true });
          this.zoomButtons.forEach((button) => button.addEventListener('click', () => this.openLightbox(Number(button.dataset.galleryOpen))));

          if (this.lightbox) {
            this.lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.lightbox.close());
            this.lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.stepLightbox(-1));
            this.lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.stepLightbox(1));
            this.lightbox.addEventListener('click', (event) => {
              if (event.target === this.lightbox) this.lightbox.close();
            });
            this.lightbox.addEventListener('keydown', (event) => {
              if (event.key === 'ArrowRight') this.stepLightbox(1);
              if (event.key === 'ArrowLeft') this.stepLightbox(-1);
            });
            this.lightbox.addEventListener('close', () => this.zoomButtons[this.zoomIndex]?.focus());
          }
        }

        go(index) {
          const slide = this.slides[index];
          if (!slide) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.target = index;
          window.clearTimeout(this.targetTimer);
          this.targetTimer = window.setTimeout(() => (this.target = null), 1000);
          this.track.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          this.setActive(index);
        }

        setActive(index) {
          this.index = index;
          [...this.thumbs, ...this.dots].forEach((control) => {
            const i = Number(control.dataset.galleryThumb ?? control.dataset.galleryDot);
            if (i === index) {
              control.setAttribute('aria-current', 'true');
            } else {
              control.removeAttribute('aria-current');
            }
          });
          if (this.counter) this.counter.textContent = index + 1;
        }

        onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = window.requestAnimationFrame(() => {
            this.scrollFrame = null;
            const width = this.track.clientWidth || 1;
            const index = Math.min(Math.max(Math.round(this.track.scrollLeft / width), 0), this.slides.length - 1);
            if (this.target != null) {
              if (index !== this.target) return;
              this.target = null;
            }
            if (index !== this.index) this.setActive(index);
          });
        };

        openLightbox(index) {
          if (!this.lightbox || typeof this.lightbox.showModal !== 'function') return;
          this.zoomIndex = index;
          this.showZoom(index);
          this.lightbox.showModal();
        }

        stepLightbox(direction) {
          if (!this.zoomButtons.length) return;
          const count = this.zoomButtons.length;
          this.zoomIndex = (this.zoomIndex + direction + count) % count;
          this.showZoom(this.zoomIndex);
        }

        showZoom(index) {
          const button = this.zoomButtons[index];
          const image = this.lightbox.querySelector('[data-lightbox-image]');
          if (!button || !image) return;
          image.src = button.dataset.zoomSrc;
          image.alt = button.dataset.zoomAlt || '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v2-recently-viewed')) {
    customElements.define(
      'v2-recently-viewed',
      class extends HTMLElement {
        async connectedCallback() {
          const list = this.querySelector('[data-recent-list]');
          if (!list) return;
          let handles = [];
          try {
            handles = JSON.parse(localStorage.getItem('abajuu:recent') || '[]');
          } catch (error) {
            handles = [];
          }
          if (!Array.isArray(handles)) handles = [];
          const max = Number(this.dataset.max) || 4;
          handles = handles.filter((handle) => handle && handle !== this.dataset.current).slice(0, max);
          if (!handles.length) return;

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const results = await Promise.all(
            handles.map((handle) =>
              fetch(`${root}products/${encodeURIComponent(handle)}?view=v2-card`)
                .then((response) => (response.ok ? response.text() : null))
                .catch(() => null)
            )
          );
          const cards = results.filter((html) => html && html.includes('v2-card'));
          if (!cards.length) return;

          list.innerHTML = cards.map((html) => `<li class="v2-recent__item">${html}</li>`).join('');
          this.querySelector('[data-recent-hint]')?.remove();
          this.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-related-products"]) return;
  try {
    
  if (!customElements.get('v2-related-products')) {
    customElements.define(
      'v2-related-products',
      class extends HTMLElement {
        async connectedCallback() {
          const list = this.querySelector('[data-related-list]');
          if (!list || list.children.length > 0 || this.dataset.useRecommendations !== 'true') return;
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const items = doc.querySelectorAll('[data-related-list] > li');
            if (!items.length) return;
            list.replaceChildren(...[...items].map((item) => document.importNode(item, true)));
            this.querySelector('.v2-related__hint')?.remove();
            this.hidden = false;
          } catch (error) {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
